import angular from 'angular';
import uiRouter from 'angular-ui-router';
import base64Upload from 'angular-base64-upload';
import AuthorizationFormComponent from './authorization-form.component';
import routing from './authorization-form.routes';

export default angular
  .module('verifyApp.public.case.authorizationForm', [uiRouter, base64Upload])
  .config(routing)
  .component('publicAuthorizationForm', AuthorizationFormComponent)
  .name;



// WEBPACK FOOTER //
// ./client/app/public/case/authorization-form/index.js